export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:5000/api/v1";
export const USE_BACKEND = false; 
export const CDN_BASE_URL = "https://assets.nimbusnode.dev";
